(function () {
  "use strict";

  a3_cabin_reports.factory("ExpiriesFactory", ExpiriesFactory);
  /**
   * @memberof CabinReports
   * @ngdoc factory
   * @name ExpiriesFactory
   * @description
   *   Get medical & passport expiries.
   * @ngInject
   */
  function ExpiriesFactory($http, apiUrl, GenericService, IndexedDBService) {
    var objType = "CrewExpiries";
    var objCallback = CrewExpiries;

    /**
     * Initialize the ScheduleChanges
     * @memberof ScheduleAcknowledgeFactory
     */
    function CrewExpiries() {
      this.expiries = [];
      this.showExpiriesModal = false;
    }

    var service = {
      setCrewExpiriesToStorage: setCrewExpiriesToStorage,
      getCrewExpiriesFromStorage: getCrewExpiriesFromStorage,
      showExpiriesModal: showExpiriesModal,
      showExpiriesAlert: showExpiriesAlert,
      updateShowExpiriesModal: updateShowExpiriesModal,
      setAllExpiriesToStorage: setAllExpiriesToStorage,
      getAllExpiriesFromStorage: getAllExpiriesFromStorage,
      showExpiredExpiriesAlert: showExpiredExpiriesAlert,
      getExpiredExpiries: getExpiredExpiries,
      exportCrewExpiriesToPdf: exportCrewExpiriesToPdf,
    };

    /**
     * Save expiries info to storage
     * @param {array} objList A list of Crew Expiries
     */
    function setCrewExpiriesToStorage(objList) {
      if (objList != null) {
        var crewExpiries = { expiries: objList, showExpiriesModal: true };
        GenericService.saveOne(crewExpiries, objType, objCallback);
      }
    }

    /**
     * Get expiries info from storage
     */
    function getCrewExpiriesFromStorage() {
      return GenericService.getOne(objType, objCallback);
    }

    function setAllExpiriesToStorage(objList) {
      if (objList && Array.isArray(objList)) {
        var allExpiries = {
          expiries: objList,
          showExpiriesModal: false,
        };

        IndexedDBService.removeAll("AllExpiries")
          .then(() => {
            return IndexedDBService.addAll("AllExpiries", objList);
          })
          .catch(function (error) {
            console.error(
              "Failed to store non-medical/passport expiries:",
              error,
            );
          });
      }
    }

    function getAllExpiriesFromStorage() {
      return IndexedDBService.getAll("AllExpiries");
    }

    /**
     * Shows expiries modal
     * @memberof ExpiriesFactory
     * @returns {bool} returns the value of showExpiriesModal property
     */
    function showExpiriesModal() {
      var crewExpiries = getCrewExpiriesFromStorage();

      var needsReminder = false;

      if (
        crewExpiries &&
        crewExpiries.expiries &&
        crewExpiries.showExpiriesModal
      ) {
        needsReminder = crewExpiries.expiries.some(function (item) {
          return (
            (item.ExpiryTypeId == 1 ||
              item.ExpiryTypeId == 2 ||
              item.ExpiryTypeId == 66) &&
            item.NeedsHardAlert
          );
        });
      }

      return needsReminder;
    }

    /**
     * Shows expiries alert
     * @memberof ExpiriesFactory
     * @returns {bool} returns the value of showExpiriesAlert property
     */
    function showExpiriesAlert() {
      var crewExpiries = getCrewExpiriesFromStorage();

      var needsAlert = false;

      if (crewExpiries && crewExpiries.expiries) {
        needsAlert = crewExpiries.expiries.some(function (item) {
          return (
            (item.ExpiryTypeId == 1 ||
              item.ExpiryTypeId == 2 ||
              item.ExpiryTypeId == 66) &&
            item.NeedsSoftAlert
          );
        });
      }

      return needsAlert;
    }

    /* Update expiries modal object to storage
     * @memberof ExpiriesFactory
     * @param {bool} canShowModal whether the modal can be displayed
     */
    function updateShowExpiriesModal(canShowModal) {
      var crewExpiries = getCrewExpiriesFromStorage();
      crewExpiries.showExpiriesModal = canShowModal;
      GenericService.saveOne(crewExpiries, objType, objCallback);
    }

    function showExpiredExpiriesAlert() {
      return getExpiredExpiries().then(function (expiredItems) {
        return expiredItems.length > 0;
      });
    }

    function getExpiredExpiries() {
      return getAllExpiriesFromStorage().then(function (crewExpiries) {
        if (!crewExpiries || !Array.isArray(crewExpiries)) {
          return [];
        }
        //var today = new Date("2016,06,01");

        var today = new Date();

        var expiredItems = crewExpiries.filter(function (item) {
          // Guard: null item or missing date => ignore (NOT expired)
          if (!item || !item.ExpiryDate) {
            return false;
          }
          var expiryDate = new Date(item.ExpiryDate);

             if (isNaN(expiryDate.getTime())) {
                return false;
            }

          var isExpired = expiryDate < today;
          var isNotMedicalOrPassport =
            item.ExpiryTypeId != 1 &&
            item.ExpiryTypeId != 2 &&
            item.ExpiryTypeId != 66;

          return isExpired && isNotMedicalOrPassport;
        });

        return expiredItems;
      });
    }

    /**
     * Export crew expiries to PDF file
     * @param {object} payload currently displayed data for export
     */
    function exportCrewExpiriesToPdf(payload) {
      return $http.post(apiUrl + "/CrewExpiries/ExportToPdf", payload, {
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "arraybuffer",
      });
    }

    return service;
  }
})();
